import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StopwatchComponent } from './stopwatch.component';
import { SecondsToHoursShared } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [CommonModule, SecondsToHoursShared],
  declarations: [StopwatchComponent],
  exports: [StopwatchComponent],
})
export class StopwatchShared {}
